<ngx-ui-loader></ngx-ui-loader>
<app-splash-screen></app-splash-screen>
<router-outlet></router-outlet>
